import {bindable} from "aurelia-framework";

export class YoutubeVideoplayer
{
    @bindable videoCode;

    @bindable width = 560;
    @bindable height = 315;
}
